import { observer } from 'mobx-react';
import { useId } from 'react';

import Select from '../../../../app/shared/components/Select/Select';
import css from './SelectPricelistForm.css';
import SelectPricelistFormState from './SelectPricelistFormState';

interface SelectPricelistFormProps {
  state: SelectPricelistFormState;
}

const SelectPricelistForm = observer(({ state }: SelectPricelistFormProps) => {
  const id = useId();

  return (
    <Select
      id={id}
      className={css.root}
      label={state.translation.label}
      value={state.pricelist.value}
      onChange={(event) => state.pricelist.onChange(event.target.value)}
    >
      {state.pricelists.map((pricelist) => (
        <option key={pricelist.id} value={pricelist.id}>
          {pricelist.name}
        </option>
      ))}
    </Select>
  );
});

export default SelectPricelistForm;
